@switch (type()) {
<!-- Velocity / property model visualization. -->
@case ("model") {
<app-xwai-model-viz [viz]="viz()" />
}

<!-- Shot gather visualization. -->
@case ("shot") {
<app-xwai-shot-viz [viz]="viz()" />
}

<!-- Unknown viz type: show the raw payload so nothing is silently dropped. -->
@default {
    <pre class="xwai-viz-unknown">{{ raw() | json }}</pre>
}
}